import { ModalHandler } from '@app-velocity/ui';

import { FeedbackModalContent } from './components/FeedbackModalContent';

export const FeedbackModal = () => {
  return (
    <ModalHandler id="feedback" channel="users">
      <FeedbackModalContent />
    </ModalHandler>
  );
};
